import { CommonModule } from '@angular/common';
import { Component, inject} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { StudyLevelFormComponent } from '../../../components/study-level/study-level-form/study-level-form.component';
import { TableGuruComponent } from '../../../components/table-guru/table-guru.component';

@Component({
  selector: 'app-study-levels-index',
  standalone: true,
  imports: [
    CommonModule,
    StudyLevelFormComponent,
    LoaderComponent,
    TableGuruComponent
  ],
  templateUrl: './study-levels-index.component.html',
  styleUrl: './study-levels-index.component.scss'
})
export class StudyLevelsIndexComponent {
  items : []  = [];
	private modalService = inject(NgbModal);
  reloadItems: boolean = false;

  editFormReference = StudyLevelFormComponent;

  constructor () {}  

	openModal(item: any) {    
    let self = this;
		const modalRef = this.modalService.open(StudyLevelFormComponent);
		modalRef.componentInstance.modalStyle = true;
		modalRef.componentInstance.item = item;
		modalRef.result.then((result) => {
      self.reloadItems = true;

      setTimeout(() => {
        self.reloadItems = false;
      }, 200);
    });
	}
}
